import { createContext, useContext } from 'react';

export const ComponentParamsContext = createContext();

export const useComponentParamsContext = () => useContext(ComponentParamsContext);
